module.exports = __webpack_public_path__ + "img/category-donation-bg-ffa.ec90571.webp";